import React from "react";

import TabPanel from "components/shared/Tabs/TabPanel";
import { User as FirebaseUser } from "firebase/auth";
import ProfileHeader from "components/shared/ProfileHeader";
import { TabPanelProps } from "types";
import { useUser } from "hooks/users";
import { Box } from "@mui/material";

interface ProfileTabProps extends TabPanelProps {
  user?: FirebaseUser | null;
}

export default function ProfileTab() {
  // need to add the rest of the form.
  const user = useUser();
  return (
    <Box sx={{ width: "100%" }}>
      <ProfileHeader user={user} />
    </Box>
  );
}
